export { default as NCollapse, collapseProps } from './src/Collapse';
export { default as NCollapseItem, collapseItemProps } from './src/CollapseItem';
